import axiosService from "@/modules/axios-service";

class TransactionsService {
  path = "/transactions";
  constructor(path = undefined) {
    if (path) {
      this.path = path;
    }
  }

  async fetchTransactions(skip = "0", take,accountId) {
    return await axiosService.get(this.path, {
      params: {
        isKh: "true",
        skip: skip,
        take: take,
        accountId: accountId,
      },
    });
  }
}

export default new TransactionsService();
